import { useState } from 'react';



const App = () => {
console.log('No Page Here');
  return (
    <div>
      <h2>No Page Here</h2>
    </div>
  );
};

export default App;